import { Box, Text } from '@usap/uicomponents'
import styled from 'styled-components'

const SubtotalStyle = {
  Container: styled(Box)`
    position: relative;
  `,
  InfoIcon: styled(Box)`
    position: absolute;
    left: 58px;
    cursor: pointer;
    padding-left: '2px'
  `,
  TooltipContainer: styled(Box)`
    position: absolute;
    left: 0;
    top: -110px;
    zIndex: 9;
    border-radius: 4px;
    box-shadow: 1px 2px 5px 1px rgba(3, 3, 3, 0.2);
    max-width: unset;
    width: 276px;

    @media screen and (min-width: 993px) and (max-width: 1210px) {
      width: 210px;
    }

    @media screen and (max-width: 310px) {
      width: 210px;
    }
  `,
  TooltipText: styled(Text)`
    font-size: 12px;
    padding: 10px;
    line-height: 18px;
  `,
  TooltipPointer: styled(Box)`
    position: absolute;
    bottom: -22px;
    left: 46px;
  `,
}

export default SubtotalStyle
